module.exports = __webpack_public_path__ + "img/7-open-template.b98b9752.png";